<template>
  <div class="drug_sold_stat_block">
    <div v-if="invoices && invoices.length" class="info_block mb-1">
      <p>Накладные поступления</p>
      <p v-for="i in invoices">
        <button v-if="!inModal" @click="showInvoice(i.id)" class="btn btn-xs btn-info newWindowBtn">
          <i class="icon-fa icon-fa-eye"></i>
        </button>
        {{ i.id }} <span class="text-muted">{{ printDate(i.delivery_date, 'DD.MM.YYYY') }}</span>
        {{ Math.round(i.qty * 100) / 100 }} x {{ Math.round(i.price * 100) / 100 }}
        ({{ Math.round(i.income_price * 100) / 100 }})
        {{ $AllCurrencies[i.currency_id]?.currency }}
        <span v-if="i.status === 5" class="badge badge-info">рез.</span>
      </p>
    </div>
    <div v-if="ordersStat" class="info_block mb-1">
      <p>Статистика за <strong>6</strong> мес.</p>
      <p>Выполненые: <strong>{{ Object.keys(ordersStat.closed?.orders_num || {}).length }}</strong>
        ({{ ordersStat.closed?.drugs }})</p>
      <p>В работе: <strong>{{ Object.keys(ordersStat.progress?.orders_num || {}).length }}</strong>
        ({{ ordersStat.progress?.drugs }})</p>

      <template v-if="Object.keys(ordersStat.rejected?.orders_num || {}).length">
        <p>Отказы за <strong>3</strong> мес. <strong>{{
            getRejectedOrders(true, 90).length + getRejectedOrders(false, 90).length
          }}</strong>
          <span>(<span>М <strong>
            <template v-if="getRejectedOrders(true, 90).length">
            <a href="#"
               @click.prevent="openInNewPage('searchOrder', {ordersId: getRejectedOrders(true, 90)})">
              {{ getRejectedOrders(true, 90).length }}
            </a>
            </template>
            <template v-else>0</template>
            </strong>
            К <strong>
              <template v-if="getRejectedOrders(false, 90).length">
            <a href="#"
               @click.prevent="openInNewPage('searchOrder', {ordersId: getRejectedOrders(false, 90)})">
              {{ getRejectedOrders(false, 90).length }}
            </a>
            </template>
            <template v-else>0</template>
            </strong>
            )</span>
          </span>
        </p>
      </template>
      <template v-if="getRejectedOrders(true, 30).length || getRejectedOrders(false, 30).length">
        <p>Отказы за <strong>30</strong> дн.
          <strong>{{ getRejectedOrders(true, 30).length + getRejectedOrders(false, 30).length }}</strong>
          (М <strong>
            <template v-if="getRejectedOrders(true, 30).length">
              <a href="#"
                 @click.prevent="openInNewPage('searchOrder', {ordersId: getRejectedOrders(true, 30)})">
                {{ getRejectedOrders(true, 30).length }}
              </a>
            </template>
            <template v-else>0</template>
          </strong>
          К <strong>
            <template v-if="getRejectedOrders(false, 30).length">
              <a href="#"
                 @click.prevent="openInNewPage('searchOrder', {ordersId: getRejectedOrders(false, 30)})">
                {{ getRejectedOrders(false, 30).length }}
              </a>
            </template>
            <template v-else>0</template>
          </strong>)
        </p>
      </template>

    </div>
    <div v-if="soldData && Object.keys(soldData).length" class="info_block mb-1 flex flex_gap_10">
      <div>
        <p>Продажи за периоды в 30 дней <span v-if="+drug.pack_set !== 1">(в зав.уп.)</span></p>
        <p v-for="(monthNum, i) in monthsList">{{ monthNames[monthNum] }}:
          <strong>{{ soldData[i + 1]?.total ?? 0 }}</strong> <span
            v-if="i === 0 && ordersStat?.progress?.drugs">( +
              <a href="#"
                 @click.prevent="openInNewPage('searchOrder', {ordersId: Object.keys(ordersStat.progress?.orders_num || {})})">{{
                  ordersStat.progress.drugs
                }}</a>)</span></p>
        <p v-html="getSoldDataTrend(soldData)"/>
      </div>
      <div class="pl-1 border-left">
        <SoldStatisticsDiff :drug="inModal ? drug : null" :soldData="soldDiffData"/>
      </div>
    </div>
    <div v-else>
      <template v-if="ordersStat && ordersStat?.progress?.drugs">
        Бронь: <a href="#"
                  @click.prevent="openInNewPage('searchOrder', {ordersId: Object.keys(ordersStat.progress?.orders_num || {})})">{{
          ordersStat.progress.drugs
        }}</a>
      </template>
    </div>
  </div>
</template>

<script>

import moment from "moment/moment";
import SoldStatisticsDiff from "@/views/nomenclature/components/SoldStatisticsDiff.vue";

export default {
  components: {SoldStatisticsDiff},
  props: ['inModal', 'fixedDates', 'invoices', 'ordersStat', 'soldData', 'drug', 'soldDiffData'],
  data() {
    return {
      monthsList: [],
      monthNamesRu: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      monthNames: {},
    }
  },
  created() {
    if (this.fixedDates) {
      const startDate = moment('2022-02-28')
      this.monthsList.push(startDate.month());
      this.monthsList.push(startDate.subtract(1, 'months').month());
      this.monthsList.push(startDate.subtract(2, 'months').month());
      let currentM = moment('2022-02-28');
      this.monthsList.forEach((mN) => {
        this.monthNames[mN] = currentM.format('DD.MM') + ' - ' + currentM.subtract(30, 'days').format('DD.MM')
      })
    } else {
      this.monthsList.push(moment().month());
      this.monthsList.push(moment().subtract(1, 'months').month());
      this.monthsList.push(moment().subtract(2, 'months').month());
      let currentM = moment()
      this.monthsList.forEach((mN) => {
        this.monthNames[mN] = currentM.format('DD.MM') + ' - ' + currentM.subtract(30, 'days').format('DD.MM')
      })
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
  },
  methods: {
    getRejectedOrders(manager = true, days = 30) {
      const dateBefore = moment().subtract(days, 'days');
      return Object.keys(this.ordersStat?.rejected?.orders_num || {}).reduce((acc, id) => {
        if (dateBefore.isBefore(this.ordersStat.rejected.orders_num[id][1])
          && (
            (manager && this.ordersStat.rejected.orders_num[id][0] === -2)
            || (!manager && this.ordersStat.rejected.orders_num[id][0] === -3)
          )) {
          acc.push(id);
        }
        return acc;
      }, []);
    },
    showInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    getSoldDataTrend(data) {
      let d = {p: 0, trend: null, text: null}
      let html = ''
      if (!data[1]) data[1] = {total: 0};
      if (!data[2]) data[2] = {total: 0};
      if (data[1].total <= 0 || data[2].total <= 0) {
        if (data[1].total === 0 && data[2].total === 0) {
          return `<span>Без продаж</span>`
        } else {
          html += `<span>${data[1].total - data[2].total} уп.</span>`
        }
      } else if (data[1].total < data[2].total) {
        d.p = Math.round(100 - (data[1].total * 100 / data[2].total))
        html += `<div class="sale_data_req red"><i class="icon-fa icon-fa-play icon-fa-rotate-90"></i><span> ${d.p}%</span></div>`
      } else if (data[2].total < data[1].total) {
        d.p = Math.round((data[1].total * 100 / data[2].total) - 100)
        html += `<div class="sale_data_req green"><i class="icon-fa icon-fa-play icon-fa-rotate-270"></i><span> ${d.p}%</span></div>`
      } else {
        html += `<span>0</span>`
      }
      return html
    },
  }
}

</script>

<style scoped>
.drug_sold_stat_block {
  text-align: left;
}

.info_block {
  border: 1px solid lightgray;
  padding: 10px;
}
</style>
